var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drop-modal",class:{ 'drop-modal--show': _vm.show }},[_c('p',[_vm._v("将图片拖至此处")]),_c('span',[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []

export { render, staticRenderFns }